module.exports = "/_next/static/images/logo-dark.75bdadf297c1be60a164d4e8a8e3bb15.svg";